module.exports = "<div *ngIf=\"user\">\r\n    <p *ngIf=\"!isRoute\" class=\"navbar-text\">{{user.name}}</p>\r\n    <button  *ngIf=\"isRoute\" class=\"btn btn-default navbar-btn profilelink\" routerLink=\"/profile\" >\r\n        {{user.name}}\r\n    </button>\r\n    <button class=\"btn btn-default navbar-btn\" (click)=\"Logout()\">Logout</button>\r\n</div>\r\n<div *ngIf=\"!user\">\r\n    <button class=\"btn btn-default navbar-btn\" (click)=\"Login()\">Login</button>\r\n</div>\r\n\r\n    "


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/avatar/avatar.component.html
// module id = 510
// module chunks = 1